import { render, staticRenderFns } from "./Contratos.vue?vue&type=template&id=1d4164e0&"
import script from "./Contratos.vue?vue&type=script&lang=js&"
export * from "./Contratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports